<template>
    <div>
        <!--内容部分 start-->
        <div>
            <!--蓝色背景 start-->
            <div class="blue_bar">
                <!--标题 start-->
                <div class="blue_title">收入总额(元)</div>
                <!--收入金额 start-->
                <div class="income">{{come.summary}}</div>
                <!--商户类别 start-->
                <div class="merchant_type">
                    <van-tag color="#00aaee" text-color="white" class="label">特约商家</van-tag>
                </div>
                <!--微信及支付宝收入 start-->
                <div class="income_type">

                    <van-row gutter="10">
                        <van-col span="8">
                            <div >
                                微信(今)
                                 <div class="kind">{{come.wxpay_summary}}</div>
                            </div>

                        </van-col>
                        <van-col span="8">
                            <div >
                            支付宝(今)
                            <!-- alipay_summary -->
                             <div class="kind">{{come.alipay_summary}}</div>
                            </div>

                        </van-col>
                          <van-col span="8">
                               <div >
                              云闪付(今)
                              <div class="kind">{{come.unionpay_summary}}</div>
                              </div>
                              </van-col>
                    </van-row>
                </div>
            </div>
            <!--蓝色背景 end-->
            <!--菜单 start-->
            <div style="margin-top: 0.3rem">
                <van-grid :column-num="3" icon-size="1rem">
					<template v-for="(menu_item,key) in menu_data">
						<van-grid-item
						:to="menu_item.menu_url"
						:key="key"
						v-if="!menu_item.is_show || is_code==1"
						:icon="menu_item.menu_img"
						:text="menu_item.menu_text"/>
					</template>
                </van-grid>
            </div>
            <!--菜单 end-->
        </div>
        <!--内容部分 end-->
    </div>
</template>

<script>
    // 菜单图片
    import merchant_information from '../../assets/images/merchant_information.png'; //商户信息
    import transaction_flow from '../../assets/images/transaction_flow.png'; //交易流水
    import Summary from '../../assets/images/express_collection.png'; //交易汇总
    // import collection_code from '../../assets/images/collection_code.png'; //收款码
    // import express_collection from '../../assets/images/express_collection.png'; //快速收款
    // import express_collection_2 from '../../assets/images/express_collection_2.png'; //快捷收款

    export default {
        name: "MerchantHomepage", //商户首页
        data() {
            return {
                  // 收入金额
                   come:"",
				   is_code:'',
                menu_data: [
                    {
                        'menu_text': "门店信息",
                        'menu_img': merchant_information,
                        'menu_url': "/StoresInformation"
                    },
                    {
                        'menu_text': "交易流水",
                        'menu_img': transaction_flow,
                        'menu_url': "/StoresTransactionFlow"
                    },

                      {
                        'menu_text': "交易汇总",
                        'menu_img': Summary,
                        'menu_url': "/StoreSummary"
                    },
                  {
                    'menu_text': "扫码点餐",
                    'menu_img': transaction_flow,
                    'menu_url': "/CodeOrder",
                    is_show:true
                  },
                  {
                    'menu_text': "扫码点餐订单",
                    'menu_img': transaction_flow,
                    'menu_url': "/Order",
                    is_show:true
                  },
                  {
                    'menu_text': "扫码点餐销售记录",
                    'menu_img': transaction_flow,
                    'menu_url': "/storeConsumer",
                    is_show:true
                  }
                   //     {
                   //      'menu_text': "我的收款码",
                   //      'menu_img': collection_code,
                   //      'menu_url': ""
                   //  },
                   //       {
                   //      'menu_text': "快捷收款",
                   //      'menu_img': express_collection_2,
                   //      'menu_url': "/QuickPayment"
                   //  },
                   // {
                   //      'menu_text': "",
                   //      'menu_img': "",
                   //      'menu_url': ""
                   //  },


                ],



                //     {
                //         'menu_text': "快速收款",
                //         'menu_img': ,
                //         'menu_url': ""
                //     },

            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
		created(){
			this.isOpenOrder();
		},
        methods: {
			isOpenOrder() {
			  this.$http
			    .get("/wechat/api.merchant_info/get_store_info", {
			      params: {
			        merchant_id: window.sessionStorage.getItem("commercialId"),
			        store_id: window.sessionStorage.getItem("store_id"),
			      },
			    })
			    .then((response) => {
			      console.log(response.data.data);
			      this.is_code = response.data.data.is_code;
			    });
			},
          //收入金额
           income(){
               this.$http.get('/wechat/user/homepage', {
                    params: {
                        merchant_id: window.sessionStorage.getItem("commercialId"),
                        store_id: window.sessionStorage.getItem("store_id"),
                    }
                }).then(response => {
                    // console.log(response.data);
                    this.come=response.data.data
                })
           }
        },
        mounted(){
            // 收入金额
            this.income()
        },
    }
</script>

<style scoped>
    /*蓝色背景*/
    .blue_bar {
        background-color: #00aaee;
        width: 100%;
        color: white;
        text-align: center;
        padding: 0.3rem 0;
    }

    /*标题*/
    .blue_title {
        color: #DEF0FD;
        line-height: 40px;
        font-size: 14px;
    }

    /*收入金额*/
    .income {
        line-height: 40px;
        font-size: 45px;
    }

    /*商户类别整体*/
    .merchant_type {
        padding: 14px 0;
    }

    /*商户类别*/
    .label {
        border: 1px solid #fff;
        border-radius: 5px;
        padding: 3px 10px;
        font-size: 16px;
    }

    /*收入类别*/
    .income_type {
        padding: 14px 0;
        font-size: 16px;

    }

    .kind{
        position: relative;
        top: 0.1rem;
        font-size: 0.5rem;
    }
</style>
